<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addSupplierOffer></addSupplierOffer>
    </v-dialog>
</template>

<script>
    import addSupplierOffer from './AddSupplierOffer.vue'
    
    import {
        SupplierOffers
    } from '../../store/namespace-helper'

    export default {
      name: 'AddSupplierOfferDialog',
      components: {
        addSupplierOffer
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[SupplierOffers.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SupplierOffers/AddSupplierOfferDialog.vue